<!-- Hover do menu: ligado fora da zona do Angular no componente (entrar e sair do menu não
     reverifica a página inteira). -->
<aside #asideElement id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
  <div class="app-brand demo px-3 overflow-visible">
    <div class="app-brand-link cursor-pointer d-flex align-items-center" (click)="layoutService.menuToggle()">
      <app-logo [showText]="!layoutService.menuCollapsed || layoutService.menuHover"></app-logo>
    </div>

    <!-- Recolher/expandir (desktop): botão redondo na borda do menu, como no Sneat — o clique no
         logo também alterna, mas sozinho não dizia que o menu fecha. -->
    <button type="button" class="menu-collapse-btn d-none d-xl-grid" (click)="layoutService.menuToggle()"
      [attr.aria-label]="layoutService.menuCollapsed ? 'Expandir menu' : 'Recolher menu'">
      <i class="ti ti-chevron-left" aria-hidden="true"></i>
    </button>

    <a href="javascript:void(0);" class="layout-menu-toggle menu-mobile-close ms-auto d-block d-xl-none"
      aria-label="Fechar menu" (click)="layoutService.menuToggle()">
      <i class="ti ti-x"></i>
    </a>
  </div>

  <div class="menu-inner-shadow"></div>

  <ul id="menu-sistem" class="menu-inner py-1">
    @for (section of menuItems; track section.title; let firstSection = $first) {
    @if (section.title) {
    <li class="menu-header small menu-section-header" [class.menu-section-header-spaced]="!firstSection">
      <span class="menu-header-text d-flex align-items-center gap-2">
        @if (section.icon) {
        <i class="menu-section-icon" [ngClass]="section.icon"></i>
        }
        <span class="menu-section-title">{{ section.title }}</span>
      </span>
    </li>
    }

    @for (item of section.items; track item.url) {
    @if (item.children?.length) {
    <!-- Grupo com submenu: fechado, o clique abre E vai pra tela principal do grupo (Anúncios →
         lista), como no admin da Shopify; aberto, o clique fecha, como no Sneat. href de verdade
         (sem routerLink, que navegaria sempre): clique do meio/Ctrl abre a lista em nova aba. -->
    <li class="menu-item menu-group" [class.active]="inGroup(item)" [class.open]="isGroupOpen(item)">
      <a [attr.href]="item.url" class="menu-link" [attr.aria-expanded]="isGroupOpen(item)"
        (click)="onGroupClick(item, $event)">
        <i class="menu-icon tf-icons" [ngClass]="item.icon"></i>
        <div class="text-truncate">{{ item.title }}</div>
        <i class="ti ti-chevron-down menu-group-chevron" aria-hidden="true"></i>
      </a>
      <ul class="menu-sub">
        @for (child of item.children; track child.url) {
        <!-- routerLink no <a> (href de verdade): clique do meio, Ctrl+clique e "abrir em nova
             aba" funcionam; no <li> o href era javascript:void(0) e a aba nova abria "blocked". -->
        <li class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="childActiveOptions">
          <a [routerLink]="[child.url]" class="menu-link" (click)="closeMobileMenu()">
            <div class="text-truncate">{{ child.title }}</div>
          </a>
        </li>
        }
      </ul>
    </li>
    } @else {
    <li class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <a [routerLink]="[item.url]" class="menu-link" (click)="closeMobileMenu()">
        <i class="menu-icon tf-icons" [ngClass]="item.icon"></i>
        <div class="text-truncate">{{ item.title }}</div>
        <!-- Assuntos abertos da fila: mesmo número do topo da tela. Menu recolhido = ponto no ícone. -->
        @if (item.url === '/pendencias' && pendingsBadge.topics() > 0) {
        @if (pendingsAsDot) {
        <span class="menu-pend-dot" aria-hidden="true"></span>
        } @else {
        <span class="badge rounded-pill bg-danger ms-auto menu-pend-badge"
          [attr.aria-label]="pendingsBadge.topics() === 1 ? '1 pendência' : pendingsBadge.topics() + ' pendências'">
          {{ pendingsBadge.topics() > 99 ? '99+' : pendingsBadge.topics() }}
        </span>
        }
        }
      </a>
    </li>
    }
    }
    }
  </ul>

</aside>
